(() => {
  const init = () => {
    document.querySelectorAll('[data-cc-live-view]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const output = root.querySelector('[data-cc-live-number]');
      if (!output) return;
      const min = Number(root.dataset.min || 6);
      const max = Number(root.dataset.max || 34);
      let value = Math.max(min, Math.min(max, Number(output.textContent) || min));
      window.setInterval(() => {
        const step = Math.floor(Math.random() * 7) - 3;
        value = Math.max(min, Math.min(max, value + step));
        output.textContent = String(value);
      }, 5000);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();


(() => {
  const button = document.querySelector('[data-cc-scroll-top]');
  if (!button) return;
  const sync = () => button.classList.toggle('is-visible', window.scrollY > 500);
  window.addEventListener('scroll', sync, { passive: true });
  button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  sync();
})();
